import React, { forwardRef } from "react";
import { Scrollbars } from "react-custom-scrollbars";

const CustomScrollbars = forwardRef((props, ref) => (
  <Scrollbars
    {...props}
    ref={ref}
    autoHide
    renderTrackHorizontal={(props) => (
      <div
        {...props}
        ref={ref}
        style={{ display: "none" }}
        className="track-horizontal"
      />
    )}
  />
));

export default CustomScrollbars;
